"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var vdl_prefix_1 = require("../util/vdl-prefix");
var classnames_1 = require("../util/classnames");
var grip_1 = require("adp-react-icons/lib/adp/grip");
var tooltip_1 = require("../tooltip");
var overlay_trigger_1 = require("../overlay/overlay-trigger");
var widget_helpers_1 = require("../util/widget-helpers");
var Handle = /** @class */ (function (_super) {
    __extends(Handle, _super);
    function Handle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isTooltipVisible: false
        };
        _this.hideTooltip = function () {
            _this.setState({
                isTooltipVisible: false
            });
        };
        _this.showTooltip = function () {
            _this.setState({
                isTooltipVisible: true
            });
        };
        return _this;
    }
    Handle.prototype.render = function () {
        var props = this.props;
        var style = props.vertical ? { bottom: props.offset + "%" } : { left: props.offset + "%" };
        var isTooltipVisible = props.showTooltip && (props.dragging || this.state.isTooltipVisible);
        var handle = (React.createElement("div", { className: classnames_1.classNames(vdl_prefix_1.vdlPrefix('slider__handle'), props.className), style: style, onMouseUp: this.showTooltip.bind(this), onMouseEnter: this.showTooltip.bind(this), onMouseLeave: this.hideTooltip.bind(this) },
            React.createElement(grip_1.default, { className: vdl_prefix_1.vdlPrefix('slider__handle__icon') })));
        if (!isTooltipVisible) {
            return handle;
        }
        var tooltipID = widget_helpers_1.instanceId(this, '_tooltip');
        var tooltipClasses = (_a = {},
            _a[vdl_prefix_1.vdlPrefix('slider__tooltip')] = true,
            _a[vdl_prefix_1.vdlPrefix('slider__tooltip--disabled')] = props.disabled,
            _a);
        var tooltip = (React.createElement(tooltip_1.Tooltip, { id: tooltipID, className: classnames_1.classNames(tooltipClasses), placement: props.vertical ? 'right' : 'top' }, props.tipFormatter
            ? props.tipFormatter(props.value, props.index)
            : undefined));
        return (React.createElement(overlay_trigger_1.OverlayTrigger, { placement: props.vertical ? 'right' : 'top', overlay: tooltip, transition: props.tipTransition }, handle));
        var _a;
    };
    return Handle;
}(React.Component));
exports.Handle = Handle;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/slider/handle.js
// module id = 606
// module chunks = 0 1 2 3 4 5 6